import axios from '@/libs/api.request'

export const getSysparameterlist = (page, limit, key, value, tables) => {
  return axios.request({
    url: '/v1/sysparameter/sysparameter/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit,
      tables
    }
  })
}

export const operationSysparameter = (data, meth) => {
  return axios.request({
    url: '/v1/sysparameter/sysparameter/',
    method: meth,
    data
  })
}
